document.addEventListener('DOMContentLoaded', function () {
	 /*
// Brand Menu Features
*/
   // Select the Brands menu link
    const brandsMenu = document.querySelector('.brands-menu');
    var brandList = document.querySelector(".brand-nav-list-container");
    const viewAllBrands = document.querySelector("a.last_brand_nav");


    // Check if both elements exist
    if (brandsMenu && brandList) {
        // Add hover event listeners
        brandsMenu.addEventListener('mouseenter', function() {
            // On hover, display the brand navigation list
            brandList.style.display = 'block';
        });

        brandsMenu.addEventListener('mouseleave', function() {
            // Optional: Hide the brand navigation list when not hovering (if needed)
            // brandList.style.display = 'none';
        });

        // Add hover event listeners for the container to keep it displayed when hovered
        brandList.addEventListener('mouseenter', function() {
            // Keep it displayed if the container itself is hovered
            brandList.style.display = 'block';
        });

        brandList.addEventListener('mouseleave', function() {
            // Hide it when the mouse leaves the container
            brandList.style.display = 'none';
        });

    }



if (brandList) {
    var brandsFilter = document.querySelector(".brands-filter");
    if (brandsFilter) {
        brandsFilter.addEventListener("mouseenter", function(event) {
            console.log("moving on button");
            brandList.classList.add("show");
        });
    }

    const navLinks = document.querySelectorAll(".nav-bar__item");
    if (navLinks.length > 0) {
        navLinks.forEach((link) => {
            link.addEventListener('mouseenter', () => {
                brandList.classList.remove("show");
            });
        });
    }

    brandList.addEventListener("mouseleave", function(event) {
        brandList.classList.remove("show");
    });
}

var topFilterLinks = document.querySelectorAll(".top-filter a.filter");

if (topFilterLinks.length > 0) {
    topFilterLinks.forEach(letter => {

        letter.addEventListener('mouseover', function(event) {

            event.preventDefault();

            let letterClicked = letter.dataset.brand;

            let filterLinks = Array.from(document.querySelectorAll('.top-filter a'));
            filterLinks.forEach(node => {
                node.classList.remove("active");
            });
            event.target.classList.add("active");

            document.querySelectorAll("ul.brands-listings li").forEach(listing => {

                // reset the view
                listing.classList.remove("show");

                // check if letterClicked equals the class name on this element and show it if confirmed
                var thisClassName = listing.className;

                if (thisClassName === letterClicked) {
                    listing.classList.add("show");
                }

            });

        });

    });
}



const activeFilter = document.querySelector('.top-filter a.filter.active');
    if (activeFilter) {
        const defaultLetter = activeFilter.getAttribute('data-brand');
        const allListings = document.querySelectorAll('ul.brands-listings li');

        allListings.forEach(item => {
            if (item.classList.contains(defaultLetter)) {
                item.classList.add('show');
            } else {
                item.classList.remove('show');
            }
        });
    } else {
        // If no active filter, fallback: show all or first letter group's items
        // For example, show all or first <li>
        const allListings = document.querySelectorAll('ul.brands-listings li');
        if (allListings.length > 0) {
            allListings.forEach(item => item.classList.remove('show'));
            allListings[0].classList.add('show');
        }
    }








var brandTitlesLinks = document.querySelectorAll('.brand_titles-page li a');
let lastScrollTop = 0;

console.log("brandTitlesLinks", brandTitlesLinks);

if (brandTitlesLinks.length > 0) {

  // Add click event listener to each link to scroll with offset
  brandTitlesLinks.forEach(link => {
    link.addEventListener('click', function(event) {
      event.preventDefault(); // Prevent the default link behavior

      // Get the target element from the link's href attribute
      const targetId = link.getAttribute('href').substring(1);
      const targetElement = document.getElementById(targetId);

      if (targetElement) {
        // Calculate the offset position with additional 50px
        const targetPosition = targetElement.getBoundingClientRect().top + window.pageYOffset - 165;

        // Scroll to the target position with offset
        window.scrollTo({
          top: targetPosition,
          behavior: 'smooth' // Smooth scrolling
        });
      }
    });
  });

}












if (brandTitlesLinks.length > 0) {

    brandTitlesLinks.forEach(anchor => {
        anchor.addEventListener('click', function(e) {
            e.preventDefault();

            // Remove 'active' class from all anchors
            document.querySelectorAll('.brand_titles-page li a').forEach(a => a.classList.remove('active'));

            // Add 'active' class to the clicked anchor
            this.classList.add('active');

            // Hide or show brand results and images based on the clicked anchor's data attribute
            let dataTitle = this.getAttribute('data-titl');

            let brandResults = document.querySelectorAll('.brand_results li');
            let brandImages = document.querySelectorAll('.brand_image span');

            if (brandResults.length > 0 && brandImages.length > 0) {
                brandResults.forEach(li => {
                    if (dataTitle !== '') {
                        if (li.getAttribute('data-res') === dataTitle) {
                            li.style.display = 'block';
                        } else {
                            li.style.display = 'none';
                        }
                    } else {
                        li.style.display = 'block';
                    }
                });

                brandImages.forEach(span => {
                    if (dataTitle !== '') {
                        if (span.getAttribute('data-res') === dataTitle) {
                            span.style.display = 'block';
                        } else {
                            span.style.display = 'none';
                        }
                    } else {
                        span.style.display = 'none';
                    }
                });

                // Show the first image span if no specific dataTitle is selected
                if (dataTitle === '') {
                    let firstSpan = document.querySelector('.brand_image span:first-child');
                    if (firstSpan) {
                        firstSpan.style.display = 'block';
                    }
                }
            }
        });
    });
}

});